import useAxios from 'axios-hooks'
import React, { useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { ModuleWrapper } from './styles'
import { FormattedMessage } from 'react-intl'

import BreadcrumbHeader from '~/components/BreadcrumbHeader'
import { MODULES_DATA } from '~/constants/tutorialModules'
import TutorialFallback from '~/assets/img/pages/tutorial-fallback.png'
import { upperCase } from 'lodash'
import { TutorialLoading } from './components/loading'

const TutorialModule = () => {
  const history = useHistory()
  const { moduleName } = useParams()

  const [{ loading, error, data }] = useAxios({
    url: '/tutorial/module/',
    method: 'GET',
    params: {
      name: upperCase(moduleName),
    },
  })

  useEffect(() => {
    if (!error) return
    history.push('/404')
  }, [error])

  return (
    <div>
      {moduleName && (
        <BreadcrumbHeader
          path={[
            { name: 'Help Center', path: '/help-center' },
            { name: MODULES_DATA[upperCase(moduleName)]?.name || 'Module' },
          ]}
        />
      )}
      {loading ? (
        <TutorialLoading />
      ) : (
        <ModuleWrapper>
          <div>
            <h2>
              <FormattedMessage id={`${moduleName} module`} />
            </h2>
            <div className="tutorial-grid">
              {data?.tutorials?.map(tutorial => (
                <a
                  key={tutorial.id}
                  className="tutorial-card"
                  href={`/tutorial/${tutorial.id}`}
                >
                  {tutorial?.image ? (
                    <img src={tutorial.image} alt="" />
                  ) : (
                    <img src={TutorialFallback} alt="" />
                  )}
                  <div className="tutorial-info">
                    <div>
                      <span className="tutorial-submodule">
                        <FormattedMessage
                          id={
                            MODULES_DATA[tutorial.module]?.submodules?.[
                              tutorial.submodule
                            ] || 'Unknown'
                          }
                        />
                      </span>
                    </div>
                    <h3 className="tutorial-title">{tutorial.title}</h3>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </ModuleWrapper>
      )}
    </div>
  )
}

export default TutorialModule
